import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BringValueWarningDialog = (props) => {
    const { open, setOpen, warningReason, warningSelectFunction } = props;
    const { t } = useTranslation();

    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>{t('BvWarningReason')}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <Typography variant="subtitle1" sx={{ whiteSpace: 'break-spaces' }}>
                                {warningReason}
                            </Typography>
                            <Typography>{t('AreYouSureYouWantToProceed')}</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" onClick={() => setOpen(false)}>
                    {t('No')}
                </Button>
                <Button
                    variant="contained"
                    sx={{ background: '#4d79bc', ':hover': { background: '#79AEC9', color: '#fff' } }}
                    onClick={() => {
                        // first close the dialog
                        setOpen(false);
                        // THEN invoke the callback
                        if (typeof warningSelectFunction === 'function') {
                            warningSelectFunction();
                        }
                    }}
                >
                    {t('Yes')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BringValueWarningDialog;
